exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".questionFeedback .feedbackQuote{font-size:.8em;border-left:1px solid #aaa;padding-left:5px;font-style:italic}.questionFeedback .feedbackNormal:last-child,.questionFeedback .feedbackQuote:last-child{margin-bottom:0}.questionFeedback .showMore{position:relative;bottom:100px;right:10px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/question_feedback.scss
// module id = 1523
// module chunks = 0